import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Container,
  Flex,
  GridItem,
  Heading,
  Text,
} from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { useUser } from '@/client/context/user'
import { getBecomeATutorUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import ShwGrid from '@/components/Layout/ShwGrid'
import ShwLink from '@/components/ShwLink'

export default function ExploreHeaderTutor(): ReactElement {
  const user = useUser()

  return (
    <Box bgColor="bg.subtle">
      <Container>
        <ShwGrid>
          <GridItem colSpan={[12, 9]}>
            <Breadcrumb
              ml={-10}
              separator={
                <FontAwesomeIcon icon={faChevronRight} size="sm" color={chakraTokenToVar('fg')} />
              }
              fontWeight="bold"
            >
              <BreadcrumbItem>
                <ShwLink href="/explore">
                  <BreadcrumbLink>Explore</BreadcrumbLink>
                </ShwLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink>Tutors</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            <Heading color="fg" as="h1" mb="4px">
              Explore Tutors
            </Heading>
            <Text as="span">A global community of volunteer tutors. </Text>
          </GridItem>
          <GridItem colSpan={[12, 3]}>
            {hasUserRole(user, 'user:tutor') ? null : (
              <Flex flexDir={['row', 'row-reverse']}>
                <ShwLink href={getBecomeATutorUrl()}>
                  <Button>Become a Tutor</Button>
                </ShwLink>
              </Flex>
            )}
          </GridItem>
        </ShwGrid>
      </Container>
    </Box>
  )
}
